import queryString from 'query-string';
import { apiClient } from '../core/client';
import { getColorsByStackHalf } from '../../utils/random-color';

const fetchAnalyticsData = async (params) => {
  const purifiedParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v != undefined && v != '')
  );
  const res = await apiClient(
    `${process.env.REACT_APP_API_URL}analytics/?${queryString.stringify(purifiedParams)}`
  );

  return res.json();
};

// Aggregate data from multiple datapoints into one
// i.e.: we filter and get back 3 days/datapoints, so we aggregate everything into one datapoint
const getAggregatedDatapoints = (datapoints) => {
  return datapoints.reduce((aggregator, datapoint) => {
    const keys = Object.keys(datapoint.y);
    keys.forEach((key) => {
      if (!aggregator[key]) {
        // skip empty datapoints
        if (datapoint.y[key] === '0~0') {
          return;
        }

        aggregator[key] = datapoint.y[key];
        return;
      }

      if (aggregator[key]) {
        const currentCAT = parseInt(aggregator[key]?.split('~')[0]);
        const currentUNCAT = parseInt(aggregator[key]?.split('~')[1]);
        const newCAT = parseInt(datapoint.y[key]?.split(`~`)[0]);
        const newUNCAT = parseInt(datapoint.y[key]?.split(`~`)[1]);

        aggregator[key] = `${currentCAT + newCAT}~${currentUNCAT + newUNCAT}`;
      }
    });

    return aggregator;
  }, {});
};

const getMetadataFromFormat = (metadata) => {
  if (metadata[0]?.datapoints?.length) {
    const aggregatedDatapoints = getAggregatedDatapoints(metadata[0].datapoints);
    const metadataCategories = metadata[0].datapoints?.[0]?.extra_data?.split('~'); // CAT, UNCAT
    const datapointsKeys = Object.keys(aggregatedDatapoints);

    return {
      labels: datapointsKeys,
      datasets: metadataCategories?.map((category, i) => ({
        label: category,
        data: datapointsKeys.map((key, j) => {
          const datapoint = aggregatedDatapoints[key]?.split('~')[i];
          return { x: j, y: datapoint };
        }),
        backgroundColor: getColorsByStackHalf(i, datapointsKeys.length)
      }))
    };
  }

  return null;
};

export const fetchAnalytics = (params) => {
  return new Promise(async (res) => {
    try {
      const rawAnalyticsData = await fetchAnalyticsData(params);

      if (rawAnalyticsData?.detail) {
        res({
          error: e,
          message: 'notFoundError'
        });
      }

      const { serialized_metadatas_region, serialized_metadatas_partner, ...rest } =
        rawAnalyticsData;

      const formattedRegionMetadatas = getMetadataFromFormat(serialized_metadatas_region);
      const formattedPartnerMetadatas = getMetadataFromFormat(serialized_metadatas_partner);

      res({
        ...rest,
        serialized_metadatas_region: formattedRegionMetadatas,
        serialized_metadatas_partner: formattedPartnerMetadatas
      });
    } catch (e) {
      res({
        error: e,
        message: 'notFoundError'
      });
    }
  });
};
